import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema } from '@/core/components';

export const departmentSchema = z.object({
  name: z.string().min(3),
  headOfDepartment: identitySchema,
  faculty: identitySchema,
});

export const defaultDepartmentValues: DefaultValues<DepartmentSchema> = {
  name: '',
};

export type DepartmentSchema = z.infer<typeof departmentSchema>;
